<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Data da Operação', 'Data do Vencimento', 'Descrição Nivel Risco Limite', 'Número Contrato Crédito', 'Valor do Contrato', '% Taxa Operação',
      'Valor Saldo Devedor Diário', 'Nivel Risco Atual', 'Provisão (R$)', 'Quantidade Parcelas', 'Quantidade Parcelas Abertas',
      'Quantidade Parcelas Pagas', 'Quantidade Dias Atraso Parcela', 'Modalidade Bacen', 'Submodalidade Bacen', 'Modalidade Produto',
      'Finalidade Operação Crédito', 'Proposta Credito Pré Autorizada', 'Origem Recurso', 'Possui Seguro Prestamista', 'Valor Premio Seguro Prestamista'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.dtOperacao ? formatDate(obj.dtOperacao) : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.dtVencimento ? formatDate(obj.dtVencimento) : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.descNivelRisco ? obj.descNivelRisco.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.numeroContrato && obj.numeroContrato != -1 ? obj.numeroContrato : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.valorContrato && obj.valorContrato != -1 ? 'R$ ' + obj.valorContrato : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.taxa ? obj.taxa.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.vlrSaldoDevedorDiario ? formatValue(obj.vlrSaldoDevedorDiario) : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.nivelRiscoAtual ? obj.nivelRiscoAtual.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.provisao ? formatValue(obj.provisao) : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.qtdParcelas ? obj.qtdParcelas : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.qtdParcelasAbertas ? obj.qtdParcelasAbertas : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.qtdParcelasPagas ? obj.qtdParcelasPagas : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.qtdDiasAtrasoParcela ? obj.qtdDiasAtrasoParcela : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.modalidadeBacen ? obj.modalidadeBacen.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.submodalidadeBacen ? obj.submodalidadeBacen.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.modalidadeProduto ? obj.modalidadeProduto.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.finalidadeCredito ? obj.finalidadeCredito.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.propCredPreAut ? obj.propCredPreAut.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.origemRecurso ? obj.origemRecurso.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.seguroPrestamista ? obj.seguroPrestamista.toString() : '-'"/>
        <TableColumn :IsText="true" :status="1" :value="obj.valorPremioSeguroPrestamista ? obj.valorPremioSeguroPrestamista.toLocaleString('pt-Br', {style: 'currency', currency: 'BRL'}) : ''"/>
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ContratosVigentesRepository from '@/shared/http/repositories/business/contratosvigentes.js'
import Tools from '@/components/tools/Tools'

export default {
  name: 'ContratosVigentes',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadContratosVigentes(this.document)
      }
    },
    onLoadContratosVigentes (document) {
      loading.push()
      this.document = document
      ContratosVigentesRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/contratosvigentes.vue